import { Skeleton } from "antd"

const LoadingIndicator = () => {
  return <Skeleton 
    active 
  />
}

export default LoadingIndicator